import VendorArticle from 'src/adminPanel/entities/articleManagement/VendorArticle';
import { action } from 'src/store/actions';

/* Vendor Article */
export const FETCH_VENDOR_ARTICLES = 'FETCH_VENDOR_ARTICLES';
export const REQUEST_VENDOR_ARTICLES = 'REQUEST_VENDOR_ARTICLES';
export const SUCCESS_VENDOR_ARTICLES = 'SUCCESS_VENDOR_ARTICLES';
export const FAILURE_VENDOR_ARTICLES = 'FAILURE_VENDOR_ARTICLES';

export const fetchVendorArticles = (articleId: string) => action(FETCH_VENDOR_ARTICLES, { articleId });
export const requestVendorArticles = () => action(REQUEST_VENDOR_ARTICLES);
export const requestVendorArticlesSuccess = (response: any) => action(SUCCESS_VENDOR_ARTICLES, { response });
export const requestVendorArticlesFailure = (error: any) => action(FAILURE_VENDOR_ARTICLES, { error });

export const CREATE_VENDOR_ARTICLE = 'CREATE_VENDOR_ARTICLE';
export const REQUEST_CREATE_VENDOR_ARTICLE = 'REQUEST_CREATE_VENDOR_ARTICLE';
export const SUCCESS_CREATE_VENDOR_ARTICLE = 'SUCCESS_CREATE_VENDOR_ARTICLE';
export const FAILURE_CREATE_VENDOR_ARTICLE = 'FAILURE_CREATE_VENDOR_ARTICLE';

export const createVendorArticleAction = (vendorArticle: VendorArticle) =>
    action(CREATE_VENDOR_ARTICLE, { vendorArticle });
export const requestCreateVendorArticle = () => action(REQUEST_CREATE_VENDOR_ARTICLE);
export const requestCreateVendorArticleSuccess = (response: any) => action(SUCCESS_CREATE_VENDOR_ARTICLE, { response });
export const requestCreateVendorArticleFailure = (error: any) => action(FAILURE_CREATE_VENDOR_ARTICLE, { error });

export const UPDATE_VENDOR_ARTICLE = 'UPDATE_VENDOR_ARTICLE';
export const REQUEST_UPDATE_VENDOR_ARTICLE = 'REQUEST_UPDATE_VENDOR_ARTICLE';
export const SUCCESS_UPDATE_VENDOR_ARTICLE = 'SUCCESS_UPDATE_VENDOR_ARTICLE';
export const FAILURE_UPDATE_VENDOR_ARTICLE = 'FAILURE_UPDATE_VENDOR_ARTICLE';

export const updateVendorArticleAction = (vendorArticle: VendorArticle) =>
    action(UPDATE_VENDOR_ARTICLE, { vendorArticle });
export const requestUpdateVendorArticle = () => action(REQUEST_UPDATE_VENDOR_ARTICLE);
export const requestUpdateVendorArticleSuccess = (response: any) => action(SUCCESS_UPDATE_VENDOR_ARTICLE, { response });
export const requestUpdateVendorArticleFailure = (error: any) => action(FAILURE_UPDATE_VENDOR_ARTICLE, { error });

export const DELETE_VENDOR_ARTICLE = 'DELETE_VENDOR_ARTICLE';
export const REQUEST_DELETE_VENDOR_ARTICLE = 'REQUEST_DELETE_VENDOR_ARTICLE';
export const SUCCESS_DELETE_VENDOR_ARTICLE = 'SUCCESS_DELETE_VENDOR_ARTICLE';
export const FAILURE_DELETE_VENDOR_ARTICLE = 'FAILURE_DELETE_VENDOR_ARTICLE';

export const deleteVendorArticleAction = (vendorArticle: VendorArticle) =>
    action(DELETE_VENDOR_ARTICLE, { vendorArticle });
export const requestDeleteVendorArticle = () => action(REQUEST_DELETE_VENDOR_ARTICLE);
export const requestDeleteVendorArticleSuccess = (response: any) => action(SUCCESS_DELETE_VENDOR_ARTICLE, { response });
export const requestDeleteVendorArticleFailure = (error: any) => action(FAILURE_DELETE_VENDOR_ARTICLE, { error });

/* Vendor Article Price */
export const FETCH_VENDOR_ARTICLE_PRICES = 'FETCH_VENDOR_ARTICLE_PRICES';
export const REQUEST_VENDOR_ARTICLE_PRICES = 'REQUEST_VENDOR_ARTICLE_PRICES';
export const SUCCESS_VENDOR_ARTICLE_PRICES = 'SUCCESS_VENDOR_ARTICLE_PRICES';
export const FAILURE_VENDOR_ARTICLE_PRICES = 'FAILURE_VENDOR_ARTICLE_PRICES';

export const fetchVendorArticlePrices = (articleId: string, vendorId: number | undefined, showPast: boolean) =>
    action(FETCH_VENDOR_ARTICLE_PRICES, { articleId, vendorId, showPast });
export const requestVendorArticlePrices = () => action(REQUEST_VENDOR_ARTICLE_PRICES);
export const requestVendorArticlePricesSuccess = (response: any) => action(SUCCESS_VENDOR_ARTICLE_PRICES, { response });
export const requestVendorArticlePricesFailure = (error: any) => action(FAILURE_VENDOR_ARTICLE_PRICES, { error });

export const CREATE_VENDOR_ARTICLE_PRICE = 'CREATE_VENDOR_ARTICLE_PRICE';
export const REQUEST_CREATE_VENDOR_ARTICLE_PRICE = 'REQUEST_CREATE_VENDOR_ARTICLE_PRICE';
export const SUCCESS_CREATE_VENDOR_ARTICLE_PRICE = 'SUCCESS_CREATE_VENDOR_ARTICLE_PRICE';
export const FAILURE_CREATE_VENDOR_ARTICLE_PRICE = 'FAILURE_CREATE_VENDOR_ARTICLE_PRICE';

export const createVendorArticlePriceAction = (vendorArticlePrice: any, articleId: string, vendorId: number) =>
    action(CREATE_VENDOR_ARTICLE_PRICE, { vendorArticlePrice, articleId, vendorId });
export const requestCreateVendorArticlePrice = () => action(REQUEST_CREATE_VENDOR_ARTICLE_PRICE);
export const requestCreateVendorArticlePriceSuccess = (response: any) =>
    action(SUCCESS_CREATE_VENDOR_ARTICLE_PRICE, { response });
export const requestCreateVendorArticlePriceFailure = (error: any) =>
    action(FAILURE_CREATE_VENDOR_ARTICLE_PRICE, { error });

export const UPDATE_VENDOR_ARTICLE_PRICE = 'UPDATE_VENDOR_ARTICLE_PRICE';
export const REQUEST_UPDATE_VENDOR_ARTICLE_PRICE = 'REQUEST_UPDATE_VENDOR_ARTICLE_PRICE';
export const SUCCESS_UPDATE_VENDOR_ARTICLE_PRICE = 'SUCCESS_UPDATE_VENDOR_ARTICLE_PRICE';
export const FAILURE_UPDATE_VENDOR_ARTICLE_PRICE = 'FAILURE_UPDATE_VENDOR_ARTICLE_PRICE';

export const updateVendorArticlePriceAction = (vendorArticlePrice: any, articleId: string, vendorId: number) =>
    action(UPDATE_VENDOR_ARTICLE_PRICE, { vendorArticlePrice, articleId, vendorId });
export const requestUpdateVendorArticlePrice = () => action(REQUEST_UPDATE_VENDOR_ARTICLE_PRICE);
export const requestUpdateVendorArticlePriceSuccess = (response: any) =>
    action(SUCCESS_UPDATE_VENDOR_ARTICLE_PRICE, { response });
export const requestUpdateVendorArticlePriceFailure = (error: any) =>
    action(FAILURE_UPDATE_VENDOR_ARTICLE_PRICE, { error });

export const DELETE_VENDOR_ARTICLE_PRICE = 'DELETE_VENDOR_ARTICLE_PRICE';
export const REQUEST_DELETE_VENDOR_ARTICLE_PRICE = 'REQUEST_DELETE_VENDOR_ARTICLE_PRICE';
export const SUCCESS_DELETE_VENDOR_ARTICLE_PRICE = 'SUCCESS_DELETE_VENDOR_ARTICLE_PRICE';
export const FAILURE_DELETE_VENDOR_ARTICLE_PRICE = 'FAILURE_DELETE_VENDOR_ARTICLE_PRICE';

export const deleteVendorArticlePriceAction = (vendorArticlePriceId: string, articleId: string, vendorId: number) =>
    action(DELETE_VENDOR_ARTICLE_PRICE, { vendorArticlePriceId, articleId, vendorId });
export const requestDeleteVendorArticlePrice = () => action(REQUEST_DELETE_VENDOR_ARTICLE_PRICE);
export const requestDeleteVendorArticlePriceSuccess = (response: any) =>
    action(SUCCESS_DELETE_VENDOR_ARTICLE_PRICE, { response });
export const requestDeleteVendorArticlePriceFailure = (error: any) =>
    action(FAILURE_DELETE_VENDOR_ARTICLE_PRICE, { error });
